import React from 'react';
import { Chip } from '@mui/material';

// Chip con borde del color del tipo de turno (Consulta/Control/Urgencia/...),
// fondo transparente — tratamiento único para appointment_type en toda la
// app (sala de espera, agenda del día, buscador de turnos, portal del
// paciente). Antes cada pantalla lo mostraba distinto (texto plano
// coloreado, texto gris sin color, chip con borde) — reportado como
// inconsistente con captura 2026-11-04: "mantengamos la coherencia en el
// diseño". El calendario (CalendarGrid.js) es la única excepción
// deliberada: ahí el tipo se pinta como barra lateral sólida + badge,
// porque el fondo del bloque ya lo ocupa el color del estado del turno (la
// señal operativa principal, ver CLAUDE.md) y un chip transparente se
// leería mal encima.
export default function AppointmentTypeChip({ appointmentType, sx }) {
  if (!appointmentType) return null;
  return (
    <Chip
      label={appointmentType.name}
      size="small"
      sx={{
        height: 22, fontSize: '0.7rem', fontWeight: 700,
        color: appointmentType.color,
        border: '1px solid', borderColor: appointmentType.color,
        bgcolor: 'transparent',
        maxWidth: '100%',
        ...sx,
      }}
    />
  );
}
